<template>
  <div class="tooltip" ref="tooltip">
    <div class="tooltip__content">
      <slot></slot>
    </div>
    <a class="fa fa-times tooltip__close" v-on:click="hide"></a>
  </div>
</template>

<script>
export default {
  methods: {
    hide() {
      this.$refs.tooltip.style.visibility = 'hidden';
    },
  },
};
</script>

<style lang="scss">
@import '~styles/app.scss';
@import '~styles/variables.scss';
@import '~styles/_mixins.scss';
@import '~styles/_animations.scss';

.tooltip {
  font-size: 14px;
  @include shadow(2);
  position: absolute;
  display: flex;
  align-items: center;
  white-space: nowrap;
  color: var(--white);
  background-color: var(--brand-orange);
  text-align: center;
  border-radius: 3px;
  visibility: visible;
  z-index: 999;
  max-height: 50px;
  right: 0px;
  animation: subtleJumpInOut 225ms ease-in-out;
  margin: 0 7.5px;
  padding-right: 5px;
  min-height: 26px;

  @media screen and (max-width: 520px) {
    max-height: 210px;
  }

  &:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 100%;
    left: -6.5px;
    width: 0;
    height: 0;
    border-right:  10px solid var(--brand-orange);
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    border-radius: 5px;
    z-index: -1;
    transform: translate(0, -50%);
  }

  &__content {
    max-height: 40px;
    overflow: hidden;
    padding: 5px;
    position: relative;
    color: var(--white);

    @media screen and (max-width: 520px) {
      max-height: 200px;
      height: auto;
      white-space: pre-wrap;
      max-width: 150px;
    }

  }

  &__close {
    color: var(--white);
    cursor: pointer;

    &:hover {
    }
  }
}

.details-table__col {

  .tooltip {
    left: 250px!important;
    right: auto!important;
    top: 50%!important;
    transform: translateY(-50%);


    @media screen and (max-width: 1370px) {
      left: auto!important;
      right: 10px!important;
    }

  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/Tooltip.vue